import React, { useState, useEffect } from 'react'
import StudentTopMenu from './studenttopmenu'
import StudentInfoBox from './studentinfobox'
import {
  addData,
  updateData,
  getStudentIdData
} from '../../../lib/studentgoalgrades'
import { useNavigate, useParams } from 'react-router-dom'

const TYPES = {
  GPA: 'GPA',
  AP: 'AP',
  Honor: 'Honor',
  SatRw: 'SatRw',
  SatMath: 'SatMath',
  DualEn: 'DualEn',
  SummerC: 'SummerC'
}

export default function AdminCurrentGoalGrades() {
  const [studentInfo, setStudentInfo] = useState(0)
  const [gpaschool, setGpaSchool] = useState(0)
  const [gpacollege, setGpaCollege] = useState(0)
  const [gpacurrent, setGpaCurrent] = useState(0.0)
  const [gpagoal, setGpaGoal] = useState(0)

  const [apschool, setApSchool] = useState(0)
  const [apcollege, setApCollege] = useState(0)
  const [apcurrent, setApCurrent] = useState(0)
  const [apgoal, setApGoal] = useState(0)

  const [honorschool, setHonorSchool] = useState(0)
  const [honorcollege, setHonorCollege] = useState(0)
  const [honorcurrent, setHonorCurrent] = useState(0)
  const [honorgoal, setHonorGoal] = useState(0)

  const [satrwschool, setSatrwSchool] = useState(0)
  const [satrwcollege, setSatrwCollege] = useState(0)
  const [satrwcurrent, setSatrwCurrent] = useState(0)
  const [satrwgoal, setSatrwGoal] = useState(0)

  const [satmathschool, setSatmathSchool] = useState(0)
  const [satmathcollege, setSatmathCollege] = useState(0)
  const [satmathcurrent, setSatmathCurrent] = useState(0)
  const [satmathgoal, setSatmathGoal] = useState(0)

  const [dualenschool, setDualenSchool] = useState(0)
  const [dualencollege, setDualenCollege] = useState(0)
  const [dualencurrent, setDualenCurrent] = useState(0)
  const [dualengoal, setDualenGoal] = useState(0)

  const [summercschool, setSummercSchool] = useState(0)
  const [summerccollege, setSummercCollege] = useState(0)
  const [summerccurrent, setSummercCurrent] = useState(0)
  const [summercgoal, setSummercGoal] = useState(0)

  const gpagoaldiff = gpagoal - gpacurrent
  const apgoaldiff = apgoal - apcurrent
  const honorgoaldiff = honorgoal - honorcurrent
  const satrwgoaldiff = satrwgoal - satrwcurrent
  const satmathgoaldiff = satmathgoal - satmathcurrent
  const dualengoaldiff = dualengoal - dualencurrent
  const summercgoaldiff = summercgoal - summerccurrent

  const navigate = useNavigate()
  let { slug } = useParams()

  async function GetData() {
    const info = await getStudentIdData(slug)
    setStudentInfo(info)

    if (info.length > 0) {
      const gpaValue = info.filter((opt) => opt.type === TYPES.GPA)
      if (gpaValue) {
        setGpaSchool(gpaValue[0].schoolGrade)
        setGpaCollege(gpaValue[0].collegeGrade)
        setGpaCurrent(gpaValue[0].currentGrade)
        setGpaGoal(gpaValue[0].goalGrade)
      }
      const apValue = info.filter((opt) => opt.type === TYPES.AP)
      if (apValue) {
        setApSchool(apValue[0].schoolGrade)
        setApCollege(apValue[0].collegeGrade)
        setApCurrent(apValue[0].currentGrade)
        setApGoal(apValue[0].goalGrade)
      }

      const honorValue = info.filter((opt) => opt.type === TYPES.Honor)
      if (honorValue) {
        setHonorSchool(honorValue[0].schoolGrade)
        setHonorCollege(honorValue[0].collegeGrade)
        setHonorCurrent(honorValue[0].currentGrade)
        setHonorGoal(honorValue[0].goalGrade)
      }

      const satRwValue = info.filter((opt) => opt.type === TYPES.SatRw)
      if (satRwValue) {
        setSatrwSchool(satRwValue[0].schoolGrade)
        setSatrwCollege(satRwValue[0].collegeGrade)
        setSatrwCurrent(satRwValue[0].currentGrade)
        setSatrwGoal(satRwValue[0].goalGrade)
      }

      const satMathValue = info.filter((opt) => opt.type === TYPES.SatMath)
      if (satMathValue) {
        setSatmathSchool(satMathValue[0].schoolGrade)
        setSatmathCollege(satMathValue[0].collegeGrade)
        setSatmathCurrent(satMathValue[0].currentGrade)
        setSatmathGoal(satMathValue[0].goalGrade)
      }

      const dualEnValue = info.filter((opt) => opt.type === TYPES.DualEn)
      if (dualEnValue) {
        setDualenSchool(dualEnValue[0].schoolGrade)
        setDualenCollege(dualEnValue[0].collegeGrade)
        setDualenCurrent(dualEnValue[0].currentGrade)
        setDualenGoal(dualEnValue[0].goalGrade)
      }

      const summerCValue = info.filter((opt) => opt.type === TYPES.SummerC)
      if (summerCValue) {
        setSummercSchool(summerCValue[0].schoolGrade)
        setSummercCollege(summerCValue[0].collegeGrade)
        setSummercCurrent(summerCValue[0].currentGrade)
        setSummercGoal(summerCValue[0].goalGrade)
      }
      //console.log("info", gpaValue);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    console.log('student', studentInfo)

    if (studentInfo.length > 0) {
      console.log('Var')
      const gpaValue = studentInfo.filter((opt) => opt.type === TYPES.GPA)
      const apValue = studentInfo.filter((opt) => opt.type === TYPES.AP)
      const honorValue = studentInfo.filter((opt) => opt.type === TYPES.Honor)
      const satRwValue = studentInfo.filter((opt) => opt.type === TYPES.SatRw)
      const satMathValue = studentInfo.filter(
        (opt) => opt.type === TYPES.SatMath
      )
      const dualEnValue = studentInfo.filter((opt) => opt.type === TYPES.DualEn)
      const summerCValue = studentInfo.filter(
        (opt) => opt.type === TYPES.SummerC
      )
      console.log('gpaValue', gpaValue[0].id)

      await updateData({
        id: gpaValue[0].id,
        instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
        schoolGrade: gpaschool,
        collegeGrade: gpacollege,
        currentGrade: gpacurrent,
        goalGrade: gpagoal
      })
      await updateData({
        id: apValue[0].id,
        instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
        schoolGrade: apschool,
        collegeGrade: apcollege,
        currentGrade: apcurrent,
        goalGrade: apgoal
      })
      await updateData({
        id: honorValue[0].id,
        instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
        schoolGrade: honorschool,
        collegeGrade: honorcollege,
        currentGrade: honorcurrent,
        goalGrade: honorgoal
      })
      await updateData({
        id: satRwValue[0].id,
        instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
        schoolGrade: satrwschool,
        collegeGrade: satrwcollege,
        currentGrade: satrwcurrent,
        goalGrade: satrwgoal
      })
      await updateData({
        id: satMathValue[0].id,
        instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
        schoolGrade: satmathschool,
        collegeGrade: satmathcollege,
        currentGrade: satmathcurrent,
        goalGrade: satmathgoal
      })
      await updateData({
        id: dualEnValue[0].id,
        instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
        schoolGrade: dualenschool,
        collegeGrade: dualencollege,
        currentGrade: dualencurrent,
        goalGrade: dualengoal
      })
      await updateData({
        id: summerCValue[0].id,
        instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
        schoolGrade: summercschool,
        collegeGrade: summerccollege,
        currentGrade: summerccurrent,
        goalGrade: summercgoal
      })
    } else {
      console.log('Yok')
      await addData([
        {
          studentId: slug,
          type: TYPES.GPA,
          order: 1,
          instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
          schoolGrade: gpaschool,
          collegeGrade: gpacollege,
          currentGrade: gpacurrent,
          goalGrade: gpagoal
        },
        {
          studentId: slug,
          type: TYPES.AP,
          order: 2,
          instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
          schoolGrade: apschool,
          collegeGrade: apcollege,
          currentGrade: apcurrent,
          goalGrade: apgoal
        },
        {
          studentId: slug,
          type: TYPES.Honor,
          order: 3,
          instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
          schoolGrade: honorschool,
          collegeGrade: honorcollege,
          currentGrade: honorcurrent,
          goalGrade: honorgoal
        },
        {
          studentId: slug,
          type: TYPES.SatRw,
          order: 4,
          instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
          schoolGrade: satrwschool,
          collegeGrade: satrwcollege,
          currentGrade: satrwcurrent,
          goalGrade: satrwgoal
        },
        {
          studentId: slug,
          type: TYPES.SatMath,
          order: 5,
          instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
          schoolGrade: satmathschool,
          collegeGrade: satmathcollege,
          currentGrade: satmathcurrent,
          goalGrade: satmathgoal
        },
        {
          studentId: slug,
          type: TYPES.DualEn,
          order: 6,
          instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
          schoolGrade: dualenschool,
          collegeGrade: dualencollege,
          currentGrade: dualencurrent,
          goalGrade: dualengoal
        },
        {
          studentId: slug,
          type: TYPES.SummerC,
          order: 6,
          instructorId: 'bb780bef-49e8-4b4b-b7e3-c75d18aae7d9',
          schoolGrade: summercschool,
          collegeGrade: summerccollege,
          currentGrade: summerccurrent,
          goalGrade: summercgoal
        }
      ])
    }
  }

  useEffect(() => {
    GetData()
  }, [])
  return (
    <div className='col-12'>
      <div className='tak-instruct-group'>
        <div className='row'>
          <div className='col-md-12'>
            <StudentInfoBox slug={slug} />
            <StudentTopMenu slug={slug} activeMenu={'GoalGrades'} />
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='checkout-form personal-address add-course-info'>
                  <div className='personal-info-head'>
                    <h4>Student Details</h4>
                  </div>
                  <form method='post' onSubmit={handleSubmit}>
                    <div className='row' style={{ backgroundColor: '#E0EAF5' }}>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <p className='fs-5'>GPA</p>
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'>School</label>
                          <input
                            type='text'
                            name='gpaschool'
                            value={gpaschool}
                            onChange={(e) => setGpaSchool(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'>College</label>
                          <input
                            type='text'
                            name='gpacollege'
                            value={gpacollege}
                            onChange={(e) => setGpaCollege(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'>Current</label>
                          <input
                            type='number'
                            step='any'
                            name='gpacurrent'
                            value={gpacurrent}
                            onChange={(e) => setGpaCurrent(e.target.value)}
                            className='form-control'
                            placeholder='0.0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'>Goal</label>
                          <input
                            type='text'
                            name='gpagoal'
                            value={gpagoal}
                            onChange={(e) => setGpaGoal(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'>
                            Goal - Existing
                          </label>
                          <input
                            type='text'
                            name='gpagoaldiff'
                            value={gpagoaldiff}
                            className='form-control'
                            placeholder='0'
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <p className='fs-5'>AP</p>
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='apschool'
                            value={apschool}
                            onChange={(e) => setApSchool(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='apcollege'
                            value={apcollege}
                            onChange={(e) => setApCollege(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='apcurrent'
                            value={apcurrent}
                            onChange={(e) => setApCurrent(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='apgoal'
                            value={apgoal}
                            onChange={(e) => setApGoal(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='apgoaldiff'
                            value={apgoaldiff}
                            className='form-control'
                            placeholder='0'
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row' style={{ backgroundColor: '#E0EAF5' }}>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <p className='fs-5'>Honor</p>
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='honorschool'
                            value={honorschool}
                            onChange={(e) => setHonorSchool(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='honorcollege'
                            value={honorcollege}
                            onChange={(e) => setHonorCollege(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='honorcurrent'
                            value={honorcurrent}
                            onChange={(e) => setHonorCurrent(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='honorgoal'
                            value={honorgoal}
                            onChange={(e) => setHonorGoal(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='honorgoaldiff'
                            value={honorgoaldiff}
                            className='form-control'
                            placeholder='0'
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <p className='fs-5'>SAT R&W</p>
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satrwschool'
                            value={satrwschool}
                            onChange={(e) => setSatrwSchool(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satrwcollege'
                            value={satrwcollege}
                            onChange={(e) => setSatrwCollege(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satrwcurrent'
                            value={satrwcurrent}
                            onChange={(e) => setSatrwCurrent(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satrwgoal'
                            value={satrwgoal}
                            onChange={(e) => setSatrwGoal(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satrwgoaldiff'
                            value={satrwgoaldiff}
                            className='form-control'
                            placeholder='0'
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row' style={{ backgroundColor: '#E0EAF5' }}>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <p className='fs-5'>SAT Math</p>
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satmathschool'
                            value={satmathschool}
                            onChange={(e) => setSatmathSchool(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satmathcollege'
                            value={satmathcollege}
                            onChange={(e) => setSatmathCollege(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satmathcurrent'
                            value={satmathcurrent}
                            onChange={(e) => setSatmathCurrent(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satmathgoal'
                            value={satmathgoal}
                            onChange={(e) => setSatmathGoal(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='satmathgoaldiff'
                            value={satmathgoaldiff}
                            className='form-control'
                            placeholder='0'
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <p className='fs-5'>Dual Enrollment</p>
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='dualenschool'
                            value={dualenschool}
                            onChange={(e) => setDualenSchool(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='dualencollege'
                            value={dualencollege}
                            onChange={(e) => setDualenCollege(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='dualencurrent'
                            value={dualencurrent}
                            onChange={(e) => setDualenCurrent(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='dualengoal'
                            value={dualengoal}
                            onChange={(e) => setDualenGoal(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='dualengoaldiff'
                            value={dualengoaldiff}
                            className='form-control'
                            placeholder='0'
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row' style={{ backgroundColor: '#E0EAF5' }}>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <p className='fs-5'>Summer Course</p>
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='summercschool'
                            value={summercschool}
                            onChange={(e) => setSummercSchool(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='summerccollege'
                            value={summerccollege}
                            onChange={(e) => setSummercCollege(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='summerccurrent'
                            value={summerccurrent}
                            onChange={(e) => setSummercCurrent(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='summercgoal'
                            value={summercgoal}
                            onChange={(e) => setSummercGoal(e.target.value)}
                            className='form-control'
                            placeholder='0'
                          />
                        </div>
                      </div>
                      <div className='col-2'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <input
                            type='text'
                            name='summercgoaldiff'
                            value={summercgoaldiff}
                            className='form-control'
                            placeholder='0'
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className='update-profile'>
                      <button type='submit' className='btn btn-primary'>
                        Update Grade
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
